import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const ButtonVariantsMap = {
  red_filled: {
    backgroundColor: "var(--color-red)",
    borderRadius: "4px",
    borderColor: "var(--color-red)",
    color: "white",
    selectors: {
      ":hover": {
        backgroundColor: "var(--color-darkred)",
        borderColor: "var(--color-darkred)",
      },
      ":disabled": {
        backgroundColor: "var(--color-disabled-bg)",
        borderColor: "var(--color-disabled-bg)",
        color: "var(--color-disabled-text)",
      },
    },
  },
  blue: {},
  blue_outlined: {
    backgroundColor: "white",
    borderRadius: "4px",
    borderColor: "var(--color-blue)",
    color: "var(--color-blue)",
    selectors: {
      ":hover": {
        color: "var(--color-darkblue)",
        borderColor: "var(--color-darkblue)",
        backgroundColor: "white",
      },
    },
  },
  primary: {
    backgroundColor: "var(--color-blue)",
    borderRadius: "4px",
    borderColor: "var(--color-blue)",
    color: "white",
    selectors: {
      ":disabled": {
        backgroundColor: "var(--color-disabled-bg)",
        borderColor: "var(--color-disabled-bg)",
        color: "var(--color-disabled-text)",
      },
      ":hover": {
        color: "white",
        borderColor: "var(--color-blue-hover)",
        backgroundColor: "var(--color-blue-hover)",
      },
    },
  },
  link: {
    color: "var(--color-blue)",
    borderRadius: "4px",
    borderColor: "var(--color-blue)",
  },
  white: {
    backgroundColor: "white",
    borderRadius: "4px",
    borderColor: "white",
    boxShadow: "1px 1px 1px 1px var(--color-grey)",
    color: "var(--color-black)",
    selectors: {
      ":hover": {
        color: "var(--color-black)",
        borderColor: "var(--color-black)",
        backgroundColor: "var(--color-white-hover)",
      },
      ":disabled": {
        backgroundColor: "var(--color-disabled-bg)",
        borderColor: "var(--color-disabled-bg)",
        color: "var(--color-disabled-text)",
      },
    },
  },
  orange: {
    backgroundColor: "rgb(234, 143, 0)",
    borderColor: "rgb(234, 143, 0)",
    borderRadius: "4px",
    selectors: {
      ":disabled": {
        backgroundColor: "rgb(234, 143, 0)",
        borderColor: "rgb(234, 143, 0)",
        color: "white",
      },
      ":hover": {
        color: "white",
        borderColor: "rgb(187, 114, 0)",
        backgroundColor: "rgb(187, 114, 0)",
      },
    },
  },
};

export const ButtonVariants = mergeStyleSets(ButtonVariantsMap);

export type ButtonVariantsEnum = keyof typeof ButtonVariantsMap;
